module.exports = __webpack_public_path__ + "static/media/Collections-Wedding-Desktop.23ab9c38.jpg";